import { render } from "./Documents.vue?vue&type=template&id=b1f70128&scoped=true"
import script from "./Documents.vue?vue&type=script&lang=js"
export * from "./Documents.vue?vue&type=script&lang=js"

import "./Documents.vue?vue&type=style&index=0&id=b1f70128&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1f70128"]])

export default __exports__